import { getCookieByName as a } from "@ado/cookie-library";
import { AFFILIATE_MAPPING as o } from "./index3.js";
function i(t) {
  let e = t;
  return e.startsWith("pid=") && (e = t.slice(4)), e.startsWith("pg-") ? e.slice(3) : "";
}
function r() {
  const e = new URLSearchParams(window.location.search).get("pid");
  return e ? i(e) : null;
}
function f() {
  const t = a("cb_QueryStringLast");
  return t ? i(t) : null;
}
function l() {
  return window.location.hostname.includes("affiliate") || window.location.hostname.includes("localhost");
}
function n() {
  const t = r() ?? f();
  let e = null;
  return t && (e = o[t.toLowerCase()]), l() ? e : null;
}
function c() {
  const t = n()?.class ?? "";
  return t + (t ? " affiliate" : "");
}
function m() {
  return n()?.name;
}
export {
  c as getAffiliateClass,
  n as getAffiliateInfo,
  m as getAffiliateName
};
//# sourceMappingURL=index2.js.map
